import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import MonthlyCyclogram from "./pages/MonthlyCyclogram/MonthlyCyclogram";
import PerspectivePlans from "./pages/PerspectivePlans/PerspectivePlans";
import QundylyqRoadmap from "./pages/QundylyqRoadmap/QundylyqRoadmap";
import Balabaqylau from "./pages/BalaBaqylau/BalaBaqylau";
import Login from "./pages/Login/Login";
import Footer from "./components/Footer/Footer";
import Cyclogram from "./pages/Cyclogram/Cyclogram";
import NoPermission from "./pages/NoPermission/NoPermission";
import ParentTool from "./pages/ParentTool/ParentTool";
import { Toaster } from "react-hot-toast";
import Quzhattar from "./pages/Quzhattar/Quzhattar";
import Ertegiler from "./pages/Ertegiler/Erteglier";
import ErtegiDetail from "./pages/Ertegiler/ErtegilDetail";
import Checklist from "./pages/Checklist/Checklist";
import Fotolar from "./pages/Fotolar/Fotolar";
import Zhattygular from "./pages/Zhattygular/Zhattygular";
import ZhattygularVideoDetail from "./pages/Zhattygular/ZhattygularVideoDetail";
import ErkinOiyn from "./pages/ErkinOiyn/ErkinOiyn";
import ErkinOiynDetail from "./pages/ErkinOiyn/ErkinOiynDetail";
import ExpertOpinion from "./pages/ExpertOpinion/ExpertOpinion";
import ExpertOpinionDetail from "./pages/ExpertOpinion/ExpertOpinionDetail";
import { ManagementPage } from "./pages/Profile/ManagementPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import NotFound from "./pages/NotFound/NotFound";
import ProfilePage from "./pages/Profile/ProfilePage";

export default function App() {
  return (
    <>
      <Toaster position="top-right" />
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <main className="flex flex-col flex-1 pt-20">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/no-permission" element={<NoPermission />} />

            {/* Protected routes - all educational/platform content */}
            <Route
              path="/monthly_cyclogram"
              element={
                <ProtectedRoute>
                  <MonthlyCyclogram />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ata_ana_bailanys"
              element={
                <ProtectedRoute>
                  <ParentTool />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ertegiler"
              element={
                <ProtectedRoute>
                  <Ertegiler />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ertegiler/:uuid"
              element={
                <ProtectedRoute>
                  <ErtegiDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quzhattar"
              element={
                <ProtectedRoute>
                  <Quzhattar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checklist"
              element={
                <ProtectedRoute>
                  <Checklist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perspektiva"
              element={
                <ProtectedRoute>
                  <PerspectivePlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qundylyq"
              element={
                <ProtectedRoute>
                  <QundylyqRoadmap />
                </ProtectedRoute>
              }
            />
            <Route
              path="/balalardy_baqylau"
              element={
                <ProtectedRoute>
                  <Balabaqylau />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fotolar"
              element={
                <ProtectedRoute>
                  <Fotolar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/erkin_oiyn"
              element={
                <ProtectedRoute>
                  <ErkinOiyn />
                </ProtectedRoute>
              }
            />
            <Route
              path="/erkin-oiyn/:uuid"
              element={
                <ProtectedRoute>
                  <ErkinOiynDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/zhattygular"
              element={
                <ProtectedRoute>
                  <Zhattygular />
                </ProtectedRoute>
              }
            />
            <Route
              path="/zhattygular/:uuid"
              element={
                <ProtectedRoute>
                  <ZhattygularVideoDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expert_opinion"
              element={
                <ProtectedRoute>
                  <ExpertOpinion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expert_opinion/:uuid"
              element={
                <ProtectedRoute>
                  <ExpertOpinionDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cyclogram"
              element={
                <ProtectedRoute>
                  <Cyclogram />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account_management"
              element={
                <ProtectedRoute>
                  <ManagementPage />
                </ProtectedRoute>
              }
            />

            {/* Catch all - redirect to no permission */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}
